import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createDefaultFilterSlice, DefaultFilterState } from '@libs/store/filters';

type FiltersState = {};
export const useTalentsFilterStore = create<DefaultFilterState & FiltersState>()(
  persist(
    (set, ...a) => ({
      ...createDefaultFilterSlice(set, ...a),
    }),
    {
      name: 'userdata:providersListFilters',
    },
  ),
);
